import { BankTransferTemplateDTO } from "../types/BankTransferTemplateDTO";
import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getBankTransferTemplates(companyId: string): Promise<BankTransferTemplateDTO[]> {
  const res = await apiFetch(
    `${API_URL}/payments/bank-transfer-templates?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać szablonów przelewów bankowych.")
    );
  }

  return res.json();
}

export async function getPaymentDocuments(
  companyId: string,
  templateName: string,
  paymentFilter?: string
) {
  const params = new URLSearchParams();
  params.set("companyId", companyId);
  params.set("template", templateName);

  if (paymentFilter) {
    params.set("paymentFilter", paymentFilter);
  }

  const res = await apiFetch(
    `${API_URL}/payments/documents?${params.toString()}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać dokumentów płatności.")
    );
  }

  return res.json();
}

export async function generatePaymentFile(
  companyId: string,
  templateId: string,
  ids: string,
  fileExtension?: string
): Promise<{ blob: Blob; filename: string }> {
  try {
    const res = await apiFetch(
      `${API_URL}/payments/generate-payment-file?companyId=${companyId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ templateId, ids, fileExtension }),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się wygenerować pliku płatności.")
      );
    }

    const blob = await res.blob();

    const disposition = res.headers.get("Content-Disposition");
    const filenameMatch = disposition?.match(/filename="(.+)"/);

    if (!filenameMatch) {
      throw new Error("Missing filename in response");
    }

    return {
      blob,
      filename: filenameMatch[1],
    };
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się wygenerować pliku płatności");
  }
}





